import { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { useSelector } from 'react-redux';
import { Chart } from 'react-google-charts';

import { MAPS_API_KEY } from 'constants/googleMaps';
import { BasicSelect } from 'ui/selects';
import { mapRegions } from 'modules/messagingInsights/constants';
import { Skeleton } from 'ui/skeleton';

import { LayoutTemplate } from './LayoutTemplate';
import {
  StyledCampaignAnalyticsCard,
  StyledLocationMapWrapper,
  SkeletonWrapper,
  Title,
  SecondMapContainer,
  FilterCardHeader,
} from './Styled';
import { selectCampaignAnalyticsStatsForTimerange, selectIsLoading } from '../selectors';
import { useLocationAndDevice } from '../hooks';
import { useFiltersContext } from '../context';

export const CampaignAnalyticsLocation = () => {
  const isLoading = useSelector(selectIsLoading);
  const statsForTimeRange = useSelector(selectCampaignAnalyticsStatsForTimerange);

  const headerRow = [['City', 'Activity']];

  const { region, setRegion } = useFiltersContext();
  const [mapData, setMapData] = useState(headerRow);
  const [mapDataFiltered, setMapDataFiltered] = useState(headerRow);

  const showLocationForFPO = useLocationAndDevice();

  const updateGeoMap = () => {
    if (statsForTimeRange?.results?.['City Data']) {
      const cityData = statsForTimeRange?.results?.['City Data'].value;
      const formattedData = Object.entries(cityData);
      setMapData(headerRow.concat(formattedData));
    }
    if (showLocationForFPO && statsForTimeRange?.results?.['City Data (filtered)']) {
      const cityDataFiltered = statsForTimeRange?.results?.['City Data (filtered)'].value;
      const formattedFilteredData = Object.entries(cityDataFiltered);
      setMapDataFiltered(headerRow.concat(formattedFilteredData));
    }
  };

  useEffect(() => {
    updateGeoMap();
  }, [statsForTimeRange]);

  return (
    <LayoutTemplate pageName="Locations">
      <StyledCampaignAnalyticsCard>
        <StyledLocationMapWrapper>
          <FilterCardHeader>
            <BasicSelect
              onSelect={setRegion}
              defaultValues={region}
              placeholder="Select a location..."
              id="location-region"
              options={mapRegions}
              title="location"
            />
          </FilterCardHeader>
          {isLoading ? (
            <SkeletonWrapper height={500}>
              <Skeleton />
            </SkeletonWrapper>
          ) : (
            <>
              {showLocationForFPO && <Title>Locations by total email opens</Title>}
              <div>
                <Chart
                  width="100%"
                  height="auto"
                  chartType="GeoChart"
                  data={mapData}
                  options={{
                    region: region[0],
                    displayMode: 'markers',
                    colors: ['#3498db', '#e74c3c'],
                  }}
                  // Note: you will need to get a mapsApiKey for your project.
                  // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
                  mapsApiKey={MAPS_API_KEY}
                />
              </div>
              {showLocationForFPO && (
                <SecondMapContainer>
                  <Title>Locations by total email opens (filtered)</Title>
                  <div>
                    <Chart
                      width="100%"
                      height="auto"
                      chartType="GeoChart"
                      data={mapDataFiltered}
                      options={{
                        region: region[0],
                        displayMode: 'markers',
                        colors: ['#3498db', '#e74c3c'],
                      }}
                      // Note: you will need to get a mapsApiKey for your project.
                      // See: https={//developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
                      mapsApiKey={MAPS_API_KEY}
                    />
                  </div>
                </SecondMapContainer>
              )}
            </>
          )}
        </StyledLocationMapWrapper>
      </StyledCampaignAnalyticsCard>
    </LayoutTemplate>
  );
};

export default withRouter(CampaignAnalyticsLocation);
